var sFCCRefererLinkStorageKey = 'SFCCRefererLink';
export var getSFCCRefererLink = function () {
    var refererLink = sessionStorage.getItem(sFCCRefererLinkStorageKey);
    return refererLink !== null && refererLink !== void 0 ? refererLink : undefined;
};
export var saveSFCCRefererLink = function (refererLink) {
    sessionStorage.setItem(sFCCRefererLinkStorageKey, refererLink);
};
export var removeSFCCRefererLink = function () {
    sessionStorage.removeItem(sFCCRefererLinkStorageKey);
};
